import { FormArray, FormGroup } from "@angular/forms";

import { MatDialog } from "@angular/material/dialog";

import { DefaultConfirmationDialogData, Dialog } from "src/app/models/dialog/dialog.model";

import { ConfirmationDialogComponent } from "../../modules/dialogs/confirmation-dialog/confirmation-dialog.component";

export class BaseSiteProducts {
  constructor(public dialog: MatDialog) {
  }

  getFormArray(form: FormGroup, formParam: string): FormArray {
    return form.get(formParam) as FormArray;
  }

  clearFormArray(formArray: FormArray) {
    formArray.clear();
  }

  openDefaultDialog(index: number, callbackFunction: Function) {
    const dialogData: Dialog = DefaultConfirmationDialogData;
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, dialogData);
    dialogRef.afterClosed().subscribe((confirmed: boolean) => {
      if (confirmed) {
        callbackFunction(index);
      }
    });
  }
}
